import i18n from "config/i18next";

i18n.addResources("es", "confirm", {
  yes: "Si",
  no: "No"
});
